import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Question } from '../../../../../../models/survey/question';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Message } from '../../../../../../models/message';
import { Router, ActivatedRoute } from '@angular/router';
import { QuestionService } from '../../../../../../services/survey/question.service';
import { QuestionTypeService } from '../../../../../../services/survey/question-type.service';
import { OptionsService } from 'src/app/services/survey/options.service';
import { Option } from 'src/app/models/survey/options';
import { SectionService } from 'src/app/services/obs/section.service';
import { SvsectionService } from 'src/app/services/survey/svsection.service';
import { SvSection } from 'src/app/models/survey/svsection';
import { LinkquestionsService } from 'src/app/services/survey/linkquestions.service';
import { LinkQuestions } from 'src/app/models/survey/linkquestions';

@Component({
  selector: 'app-svquestion-form',
  templateUrl: './svquestion-form.component.html',
  styleUrls: ['./svquestion-form.component.scss']
})
export class SvquestionFormComponent implements OnInit, OnChanges {

  form: FormGroup;
  svsections: SvSection[] = null;
  svsection: SvSection = null;
  svquestion: Question = null;
  questions: Question[] = [];
  linkQuestions: LinkQuestions[] = [];
  options: Option[] = [];
  msg: Message = { status: null, message: null };
  hiddenMsg: boolean = true;
  edit: boolean = false;
  idsectionSelected: number = null;
  typequestions: any = null;
  params: any = null;

  constructor(
    private router: Router,
    private sectionS: SvsectionService,
    private questionS: QuestionService,
    private quesiontypeS: QuestionTypeService,
    private linkService: LinkquestionsService,
    private optionS: OptionsService,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.params = this.activedRoute.snapshot.params;
    this.createForm();
    this.getQuestionType();
    this.getSvQuestion(this.params);
    this.getLinks4Question(this.params);
  }

  ngOnChanges() {
    this.getLinks4Question(this.params);

  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      idquestiontype: [null],
      idsection: [null],
      label: ['', Validators.required],
      summary: [],
      detail: [],
      order: ['', Validators.required],
      isRequired: [true],
      isQuestionBinding: [],
      idtriggerquestion: [],
      isSectionBinding: [],
      idtriggersection: [],
      idoption: [],
      isActive: [true]
    })
  }

  getSvQuestion(params: any) {
    if (params.id) {
      this.questionS.getOne(params.id)
        .subscribe(
          res => {
            this.svquestion = res['data'];
            this.idsectionSelected = this.svquestion.idsection;
            this.getLabels4Section(this.idsectionSelected);
            this.getOptions(this.svquestion.id);
            this.edit = true;
            this.getSvSection(this.idsectionSelected);
            this.loadData();
          },
          err => console.error(err)
        );
    } else if (params.idsection) {
      this.idsectionSelected = params.idsection;
      this.getLabels4Section(this.idsectionSelected);
      this.edit = false;
    }
  }
  /* Retorna los datos de la sección de la pregunta*/
  getSvSection(id: number) {
    this.sectionS.getOne(id.toString())
      .subscribe(
        res => {
          this.svsection = res['data'];
          this.getSection4Survey(this.svsection.idsurvey);
          this.svsection = null;
        },
        err => console.error(err)
      );
  }

  /* Lista secciones de la encuesta */
  getSection4Survey(idsurvey: number) {
    this.sectionS.get4Survey(idsurvey.toString())
      .subscribe(
        res => {
          this.svsections = res['data'];
        },
        err => console.error(err)
      );
  }

  /* Lista las etiquetas de las preguntas de una sección */
  getLabels4Section(idsection: number) {
    this.questionS.getLabels4Section(idsection.toString())
      .subscribe(
        res => {
          this.questions = res['data'];
        },
        err => console.error(err)
      );
  }

  /* Lista todos los tipos de pregunta activos */
  getQuestionType() {
    this.quesiontypeS.getAll().subscribe(
      res => {
        this.typequestions = res['data'];
      },
      err => {
        this.msg = err;
      }
    );
  }

  /*  Listar los enlaces de pregunta-pregunta y pregunta-sección */
  getLinks4Question(params: any) {
    if (params.id) {
      this.linkService.get4Question(params.id.toString())
        .subscribe(
          res => {
            this.linkQuestions = res['data'];
            console.log("Links: ", this.linkQuestions);
          },
          err => console.error(err)
        );

    }
  }

  addLinkQuestions(idquestion: number, idoption: number, idtriggerquestion: number, idtriggersection: number) {

    let isDuplicate: boolean = false;
    let temp: LinkQuestions = {
      idquestion, idoption, idtriggerquestion, idtriggersection
    }
    console.log("LinkQuestions: ", temp);
    if (this.linkQuestions.length > 0) {
      this.linkQuestions.forEach(lk => {
        if (lk.idoption == idoption &&
          (lk.idtriggerquestion == idtriggerquestion || lk.idtriggersection == idtriggersection)) {
          isDuplicate = true;
        }
      });
      if (isDuplicate == false) {
        this.linkQuestions.push(temp);
        this.createLink(idquestion, idoption, idtriggerquestion, idtriggersection);
      }
    } else {
      this.linkQuestions.push(temp);
      this.createLink(idquestion, idoption, idtriggerquestion, idtriggersection);
    }
  }

  getOptions(idquestion: number) {
    this.optionS.get4question(idquestion.toString())
      .subscribe(
        res => {
          this.options = res['data'];
        },
        err => console.error(err)
      );
  }

  loadData() {
    this.form.reset(this.svquestion);
  }

  cancel() {
    this.routingToList();
  }

  validateForm() {
    if (this.form.invalid) {
      return Object.values(this.form.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      this.edit ? this.update(this.form.value.id, this.form.value) : this.create(this.form.value);

    }
  }

  resetQuestionBindingForm() {
    this.form.get('isSectionBinding').setValue(false);
    this.form.get('idoption').setValue(null);
    this.form.get('idtriggerquestion').setValue(null);
  }

  resetSectionBindingForm() {
    this.form.get('isQuestionBinding').setValue(false);
    this.form.get('idoption').setValue(null);
    this.form.get('idtriggersection').setValue(null);
  }

  routingToList() {
    this.router.navigate(['/encuesta/encuestas/seccion/question/list', this.idsectionSelected]);
  }

  create(svquestion: Question) {
    delete svquestion.id;
    svquestion.idsection = +this.idsectionSelected;
    this.questionS.create(svquestion)
      .subscribe(
        res => {
          this.msg.message = res['message'];
          this.hiddenMsg = false;
          this.routingToList();
        },
        err => {
          this.msg.status = err["error"].status;
          this.msg.message = err["error"].message;
        }
      )
  }

  update(id: string, svquestion: Question) {
    delete svquestion.id;
    if (svquestion.isQuestionBinding == false) svquestion.idtriggerquestion = null;
    if (svquestion.isSectionBinding == false) svquestion.idtriggersection = null;

    this.questionS.update(id, svquestion).subscribe(
      res => {
        this.msg.message = res['message'];
        this.routingToList();
      },
      err => {
        this.msg.status = err["error"].status;
        this.msg.message = err["error"].message;
      }
    );
  }

  createLink(idquestion: number, idoption: number, idtriggerquestion: number, idtriggersection: number) {
    let link: LinkQuestions = {};
    link.idquestion = idquestion;
    link.idtriggerquestion = idtriggerquestion;
    link.idtriggersection = idtriggersection;
    link.idoption = idoption;
    this.linkService.create(link)
      .subscribe(
        res => {
          this.msg.message = res['message'];

        },
        err => {
          this.msg.status = err["error"].status;
          this.msg.message = err["error"].message;
        }
      )
  }

  removeLinks(i: number) {
    this.linkQuestions.forEach((lk, j) => {
      if (lk.id) {
        if (j == i) {
          this.linkService.delete(lk.id.toString()).subscribe(
            res => {
              this.msg.message = res['message'];
              this.msg.status = res['status'];
              this.getLinks4Question(this.params);
            },
            err => {
              this.msg.message = err["error"].message;
              this.msg.status = err["error"].status;
            }
          );
        }
      } else {
        this.linkQuestions.splice(i);
      }
    });
  }

  campoNoValido(campo: string) {
    return this.form.get(campo).invalid && this.form.get(campo).touched;
  }
}
